import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import { theme } from "../../Theme";

const PrettoSlider = styled(Slider)({
  color: theme.palette.primary.main,
  height: 8,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: theme.palette.primary.main,
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

export default function CustomizedSlider({ sliderValue, setSliderValue, setChangedSliderValue }) {
  return (
    <PrettoSlider
      valueLabelDisplay="auto"
      aria-label="pretto slider"
      value={Math.round(sliderValue)}
      onChange={(e, newValue) => {
        setChangedSliderValue(true);
        setSliderValue(newValue);
      }}
    />
  );
}
